import { render, staticRenderFns } from "./ContratoHeader.vue?vue&type=template&id=4c46c9d3&scoped=true&"
import script from "./ContratoHeader.vue?vue&type=script&lang=js&"
export * from "./ContratoHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContratoHeader.vue?vue&type=style&index=0&id=4c46c9d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46c9d3",
  null
  
)

export default component.exports